import httpRequest from '../../utils/httpRequest';
import API from '@/api';

const SERVER_NAME = 'logistics/etcCard';
/**
 * 设备列表
 */
export function queryPage(data) {
    return httpRequest({
        url: '/queryPage',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}
/**
 * 卡片绑定设备
 */
export function bindingCard(data) {
    return httpRequest(
        {
            url: '/bindingCard',
            serverName: SERVER_NAME,
            method: 'post',
            data,
        },
        {
            resolveError: true,
        }
    );
}
// 切换设备持有方
export function checkCarrier(params) {
    return httpRequest(
        {
            url: '/updateCardCarrier',
            serverName: SERVER_NAME,
            method: 'get',
            params,
        },
        {
            resolveError: true,
        }
    );
}
/**
 * 卡片取消设备
 */
export function Unbind(data) {
    return httpRequest(
        {
            url: '/unbind',
            serverName: SERVER_NAME,
            method: 'post',
            data,
        },
        {
            resolveError: true,
        }
    );
}

/**
 * 清空所属承运商
 */
export function emptyCarrier(params) {
    return httpRequest(
        {
            url: '/emptyCardCarrier',
            serverName: SERVER_NAME,
            method: 'get',
            params,
        },
        {
            resolveError: true,
        }
    );
}
